import { render, staticRenderFns } from "./DeviceRoutes2.vue?vue&type=template&id=16798d53&scoped=true"
import script from "./DeviceRoutes2.vue?vue&type=script&lang=js"
export * from "./DeviceRoutes2.vue?vue&type=script&lang=js"
import style0 from "./DeviceRoutes2.vue?vue&type=style&index=0&id=16798d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16798d53",
  null
  
)

export default component.exports